import { render, staticRenderFns } from "./CzzcBlock.vue?vue&type=template&id=52c2896e&scoped=true"
import script from "./CzzcBlock.vue?vue&type=script&lang=js"
export * from "./CzzcBlock.vue?vue&type=script&lang=js"
import style0 from "./CzzcBlock.vue?vue&type=style&index=0&id=52c2896e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c2896e",
  null
  
)

export default component.exports